<template>
  <div class="content" style="height:100%;">
    <td >
		</td>

    <div class="card">
      <div class="footer-top" style="height:35px;"></div>
      <img class="success" src="../../assets/images/success.png" />
      <div class="footer">您近期已填写过该问卷，无需再次填写，感谢您的支持</div>
    </div>
  </div>
</template>

<script>
import API from '@/api/common';
export default {
  name: "success",
  data() {
    return {
      openid: this.$route.query.openid,
      examId: this.$route.query.examId,
      coverUrl: '',
      defaultCoverUrl: require('../../assets/images/logo_ch.png')
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {

    }
  }
  
};
</script>

<style lang="less" scoped>
.content {
  background-color: #fff;
  .banner {
    width: 100%;
    height: auto;
  }

  .card {
    position: relative;
    // top: -175px;
    // width: 90%;
    margin-bottom: 30px;
    height: 60vh;
    margin: 0 auto;
    border-radius: 6px;

    .title {
      display: inline-block;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      width: 100%;
      margin: 20px auto;
    }

    .success {
      display: block;
      width: 50%;
      height: auto;
      margin: 40px auto;
    }

    .footer {
      font-size: 20px;
      font-weight: bold;
      text-align: center;
    }
  }
}
</style>
